import React from "react";
import { Paper, Typography } from "@mui/material";
import MarMonthlyTable from "../../../resident/marMonthlyTable";

export default function MarMonthlyView({ meds, doses, selectedDate, onCellClick }) {
    if (!selectedDate) return null;

    return (
        <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Monthly MAR —{" "}
                {selectedDate.toLocaleString("default", { month: "long" })}{" "}
                {selectedDate.getFullYear()}
            </Typography>

            <MarMonthlyTable
                meds={meds}
                doses={doses}
                selectedDate={selectedDate}
                forPrint={false}
                onCellClick={onCellClick}
            />
        </Paper>
    );
}
